// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ContactLensEyeResponse } from './contact-lens-eye-response';

// @ts-ignore
import { DurationResponse } from './duration-response';

// @ts-ignore
import { MasterReferenceDataResponse } from './master-reference-data-response';

/** See com.rev360.pms.api.controller.prescription.ContactLensEyeHybridResponse */
/* istanbul ignore next */
@GandalfModel
export class ContactLensEyeHybridResponse extends ContactLensEyeResponse {

	@GandalfProperty({ designType: Number })
	addPower!: number | null;

	@GandalfProperty({ designType: MasterReferenceDataResponse })
	addZoneSize!: MasterReferenceDataResponse | null;

	@GandalfProperty({ designType: Number })
	axis!: number | null;

	@GandalfProperty({ designType: Number })
	baseCurve!: number | null;

	@GandalfProperty({ designType: Number })
	cylinder!: number | null;

	@GandalfProperty({ designType: MasterReferenceDataResponse })
	design!: MasterReferenceDataResponse | null;

	@GandalfProperty({ designType: Number })
	diameter!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	isMonovision!: boolean | null;

	@GandalfProperty({ designType: Number })
	locationProductId!: number | null;

	@GandalfProperty({ designType: Number })
	locationProductItemId!: number | null;

	@GandalfProperty({ designType: String })
	locationProductName!: string | null;

	@GandalfProperty({ designType: DurationResponse })
	overnightSchedule!: DurationResponse | null;

	@GandalfProperty({ designType: Number })
	productColorId!: number | null;

	@GandalfProperty({ designType: String })
	productColorName!: string | null;

	@GandalfProperty({ designType: DurationResponse })
	replacementSchedule!: DurationResponse | null;

	@GandalfProperty({ designType: MasterReferenceDataResponse })
	segmentSize!: MasterReferenceDataResponse | null;

	@GandalfProperty({ designType: MasterReferenceDataResponse })
	skirtCurveRadius!: MasterReferenceDataResponse | null;

	@GandalfProperty({ designType: Number })
	sphere!: number | null;

	@GandalfProperty({ designType: String })
	tint!: string | null;

	@GandalfProperty({ designType: Number })
	vault!: number | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

}
